<template>
    <div class="indicator">
        <div :class="ballClass">
            <slot>
                {{ title }}
            </slot>
        </div>
        <div v-if="!withoutLine" class="indicator__line" />
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: null,
        },
        isValid: {
            type: Boolean,
            default: true,
        },
        withoutLine: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ballClass() {
            return this.isValid ? 'indicator__ball--blue' : 'indicator__ball'
        },
    },
}
</script>
<style lang="scss" scoped>
$color-blue: #009bdb;

.indicator {
    position: relative;
}

.indicator__line {
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 30px;
    height: calc(100% + 15px);
    width: 1px;
    background: $color-blue;
}

.indicator__ball {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 1.8rem;
    font-weight: 600;
    width: 70px;
    height: 70px;
    margin-right: auto;
    background: white;
    color: $color-blue;
    border: solid 1px $color-blue;
    border-radius: 50%;
}

.indicator__ball--blue {
    @extend .indicator__ball;
    color: white;
    transition-duration: 0.5s;
    background: $color-blue;
}
</style>
